import React from 'react';
import './stageshow.css';

const Chrome: React.FC<{ title: string }> = ({ title }) => (
  <div className="ss-chrome"><i /><i /><i /><span>{title}</span></div>
);

/** Stageshow still: an assistant thread where the bot calls GoTruTax and answers with the tax. Decorative. */
export const AssistantStill: React.FC<{ product: string }> = ({ product }) => (
  <div className="ss-stage ss-stage-chat ss-stage-fit" role="presentation" aria-hidden="true" data-slot="assistant-hero">
    <div className="ss-window">
      <Chrome title={product} />
      <div className="ss-thread">
        <div className="ss-msg ss-msg-me">What’s the sales tax on a $120 jacket shipped to 10001?</div>
        <div className="ss-tool"><span className="ss-dot" />Used GoTruTax · calculate_sales_tax</div>
        <div className="ss-msg ss-msg-bot">
          <strong>$10.65 sales tax (8.875%)</strong>
          <b className="ss-bar" style={{ width: '82%' }} /><b className="ss-bar ss-bar-thin" style={{ width: '64%' }} />
        </div>
        <div className="ss-msg ss-msg-me ss-msg-ghost"><b className="ss-bar" style={{ width: 140, background: '#dbe5fd' }} /></div>
      </div>
    </div>
    <div className="ss-satellite">
      <span className="ss-sat-eyebrow">New York, NY</span>
      <strong>Clothing over $110</strong>
      <span className="ss-sat-num">8.875%</span>
      <small>Items under $110 are exempt</small>
    </div>
  </div>
);

/** Stageshow still: a checkout summary with the tax line split by jurisdiction. Decorative. */
export const CheckoutStill: React.FC = () => (
  <div className="ss-stage ss-stage-fit" role="presentation" aria-hidden="true" data-slot="answers-hero" data-variant="fit">
    <div className="ss-window">
      <Chrome title="Checkout" />
      <div className="ss-receipt">
        {[['Running shoes', '$89.00'], ['Wool socks', '$14.00']].map(([n, v]) => (
          <div className="ss-line" key={n}><span>{n}</span><span className="ss-num">{v}</span></div>
        ))}
        <div className="ss-line ss-line-mute"><b className="ss-bar" style={{ width: 120 }} /><b className="ss-bar" style={{ width: 48 }} /></div>
        <div className="ss-line ss-line-on"><span>Sales tax · Austin, TX</span><span className="ss-num">$8.50</span></div>
        <div className="ss-line ss-line-total"><span>Total</span><span className="ss-num">$111.50</span></div>
        <div className="ss-line ss-line-note"><span>Texas 6.25% + Austin 2% = 8.25%</span></div>
      </div>
    </div>
  </div>
);
